export abstract class ErrorBase implements Error
{
  private _message: string = undefined;
  private _reference: Array<string> = [];
  protected _name: string = 'Error';
  protected _closeable: boolean = false;

  public title: string;
  public text: string;

  public constructor(message: string|undefined = undefined,
                     reference: Array<string> = [],
                     closeable: boolean = true)
  {
    this._message = message;
    this._reference = reference;
    this._closeable = closeable;
  }

  public get message(): string
  {
    return this._message;
  }

  public set message(message: string)
  {
    this._message = message;
  }

  public get reference(): Array<string>
  {
    return this._reference;
  }

  public set reference(reference: Array<string>)
  {
    this._reference = reference;
  }

  public get name(): string
  {
    return this._name;
  }
}
(<any>Object).setPrototypeOf(ErrorBase.prototype, Error.prototype);

export class CriticalError extends ErrorBase
{
  protected _name: string = 'CriticalError';

  public closeable(): boolean
  {
    return false;
  }
}

export class TrivialError extends ErrorBase
{
  protected _name: string = 'TrivialError';

  public closeable(): boolean
  {
    return this._closeable;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/error/error.ts